export default __webpack_public_path__ + "static/media/hdb-blob-0.d8dc1389.svg";